// Grid
export const COLUMNS = 4;

export const ROW_GAP = 20;
// export const COLUMN_GAP = 25;
export const COLUMN_GAP = 26;

export const ROUTES = {
  HOME: '/',
  LOGIN: '/auth/login',
  REGISTER: '/auth/register',
};
